<app-background urlNavigation="/#/login">
  <div class="form-container">
    <form
      id="id-update-cpf-form"
      [formGroup]="updateCpfForm"
      class="form"
    >
      <h5 class="form-title">Complete seu Cadastro</h5>
      <p class="form-description">
        Preencha seu CPF para completar seu cadastro e ter acesso a nossa plataforma.
      </p>
      <div>
        <field-validate fieldName="Digite seu CPF">
          <input
            #cpf
            type="text"
            id="cpf"
            formControlName="cpf"
            mask="000.000.000-00"
            placeholder="000.000.000-00"
          />
        </field-validate>
      </div>
      <button
        data-testid="recover-password-submit-button"
        type="submit"
        id="id-recover-password-btn-submit"
        class="btn-submit"
        (click)="onSubmit()"
      >
        Continuar
      </button>
      <div class="text-center">
        <span id="id-update-cpf-cancel" class="update-cpf-cancel">
          <a
            (click)="onCancel()"
            data-testid="sign-up-button"
            class="update-cpf-cancel__link"
            >Cancelar
          </a>
        </span>
      </div>
    </form>
  </div>
</app-background>
